import React from 'react'

import { ChatMessages } from '../../../../../Chat/components/ChatMessages/ChatMessages'

import './FocusChat.scss'

const FocusChat = () => {
  return (
    <div className="focus-chat">
      <ChatMessages type="chat" />
    </div>
  )
}

export { FocusChat }
